export function partition<T>(source: T[], filter: (x: T) => boolean): { keep: T[]; remove: T[] } {
    return source.reduce<{ keep: T[]; remove: T[] }>(
        (s, k) => {
            s[filter(k) ? 'keep' : 'remove'].push(k);
            return s;
        },
        { keep: [], remove: [] }
    );
}